export function popup() {
  const popup = document.querySelectorAll('.js-popup');
  const popupClose = document.querySelectorAll('.js-popup-close');
  const trigger = document.querySelectorAll('.js-popup-trigger');
  if(trigger && popup) {
    for(let i = 0; i < trigger.length; i++) {
      const _trigger = trigger[i];
      _trigger.addEventListener('click', function(e) {
        const popupId = _trigger.getAttribute('data-popup-id');
        const targetPopup = document.querySelector(`.js-popup[data-popup-id="${popupId}"]`);
        for(let i = 0; i < popup.length; i++) {
          const _popup = popup[i];
          _popup.classList.remove('is-active');
        }
        document.body.classList.add('is-popup-active');
        targetPopup.classList.add('is-active');
        e.preventDefault()
      });
    }
  }
  if(popupClose) {
    for(let i = 0; i < popupClose.length; i++) {
      const _popupClose = popupClose[i];
      _popupClose.addEventListener('click', function(e) {
        for(let i = 0; i < popup.length; i++) {
          const _popup = popup[i];
          document.body.classList.remove('is-popup-active');
          _popup.classList.remove('is-active');
        }
        e.preventDefault()
      })
    }
  }
}